import { Component } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { BaseMenuComponent } from './base.menu';
import { AppConstants } from '../utils/appConstants.class';
import { PeopleService } from '../shared/services';
import { SectionClipboardService } from '../shared/services/section-clipboard.service';
import { Inspection } from '../shared/models';

@Component({
    templateUrl: './section.menu.html',
    standalone: false
})
export class SectionMenuComponent extends BaseMenuComponent {
  public anyFolders = false;
  public anyPoints = false;
  public showFoldersMenu = false;
  public isTemplate = false;
  public currentPerson: any;
  public inspection: Inspection;

  constructor(
    public modal: ModalComponent,
    private peopleService: PeopleService,
    private clipboard: SectionClipboardService
  ) {
    super(modal);
    this.selectedGroup = 'general';
    this.peopleService.getCurrent().subscribe((res) => (this.currentPerson = res));
  }

  public init(data: any) {
    this.inspection = data.inspection;
    this.anyFolders = data.anyFolders;
    this.anyPoints = data.anyPoints;
    this.showFoldersMenu = data.showFoldersMenu;
    this.isTemplate = data.isTemplate;
  }

  public isPaste(): boolean {
    return this.clipboard.hasData(this.inspection);
  }

  public get isInOffline() {
    return this.inspection.isOffline;
  }
}
